import { ProductState } from '@/domain/product/model/product/enum';

export const isDisplayable = (status: ProductState): boolean => {
  let result = false;
  if (status === ProductState.SALE || status === ProductState.SOLD_OUT) {
    result = true;
  }
  return result;
};
